import React from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { DashboardFilterProvider } from '../contexts/DashboardFilterContext';
import PlaceholderDashboard from './PlaceholderDashboard';
import DashboardSuperAdmin from './DashboardSuperAdmin/DashboardSuperAdmin';
import DashboardStaff from './DashboardStaff';
import OwnerDashboard from './Owner/Dashboard/Dashboard';

const DashboardOrPlaceholder: React.FC = () => {
  const { isSuperAdmin, isSalonStaff, isSalonOwner } = useAuthContext();

  if (isSuperAdmin) {
    return (
      <DashboardFilterProvider>
        <DashboardSuperAdmin />
      </DashboardFilterProvider>
    );
  }

  if (isSalonStaff) {
    return <DashboardStaff />;
  }

  if (isSalonOwner) {
    return <OwnerDashboard />;
  }

  return <PlaceholderDashboard />;
};

export default DashboardOrPlaceholder;
